jest.mock("@/config/brands", () => ({
  default: {
    pasos: {
      paso1: { path: "/paso1", component: "components/Paso1.vue" }
    }
  },
  __esModule: true
}));
import config from "@/config";
import router from "@/router";
import conf from "@/config/brands";

jest.mock("@/router", () => ({
  addRoutes: jest.fn()
}));

describe("config", () => {
  it("starts correctly", () => {
    const callback = jest.fn();
    config.start(callback);
    expect(router.addRoutes).toHaveBeenCalled();
    expect(callback).toHaveBeenCalled();
  });

  it("gets correct config", () => {
    expect(config.get()).toEqual(conf);
  });

  it("gets correct paso properties", () => {
    const paso = "paso1";
    expect(config.getPasoProperties(paso)).toEqual(conf.pasos[paso]);
  });

  it("returns undefined for non-existing paso", () => {
    const paso = "non-existing";
    expect(config.getPasoProperties(paso)).toBeUndefined();
  });
});
